const GET_BEST_LISTS = 'GET_BEST_LISTS';
const FETCH_BEST_LISTS = 'FETCH_BEST_LISTS';
const REMOVE_DATA = 'REMOVE_DATA';
const SET_DATA = 'SET_DATA';
const SET_LINKS = 'SET_LINKS';
const CREATE_NEW_BEST_LIST = 'CREATE_NEW_BEST_LIST';
const GET_BRANCHES_FOR_PERFDB = 'GET_BRANCHES_FOR_PERFDB';
const GET_BRANCH_BY_NAME_AND_MASTERID = 'GET_BRANCH_BY_NAME_AND_MASTERID';
const GET_FILTERED_BRANCHES_FOR_PERFDB = 'GET_FILTERED_BRANCHES_FOR_PERFDB';
const GET_BEST_LISTS_FOR_SELECTOR = 'GET_BEST_LISTS_FOR_SELECTOR';
const FULL_UPDATE_BESTLIST = 'FULL_UPDATE_BESTLIST';
const GET_BESTLIST_BY_ID = 'GET_BESTLIST_BY_ID';
const CREATE_DLO_DEFS = 'CREATE_DLO_DEFS';
const COPY_DEF_FROM_EXISTING = 'COPY_DEF_FROM_EXISTING';
const CREATE_EVENT_CLASS = 'CREATE_EVENT_CLASS';
const CREATE_EVENT_CLASS_ARRAY = 'CREATE_EVENT_CLASS_ARRAY';
const GET_CUSTOM_DEFS = 'GET_CUSTOM_DEFS';
const UPDATE_CUSTOM_DEF = 'UPDATE_CUSTOM_DEF';
const DELETE_BEST_LIST = 'DELETE_BEST_LIST';
const GET_PERFORMANCELIST_LINKS = 'GET_PERFORMANCELIST_LINKS';

export default {
	GET_BEST_LISTS,
	FETCH_BEST_LISTS,
	REMOVE_DATA,
	SET_DATA,
	CREATE_NEW_BEST_LIST,
	GET_BRANCHES_FOR_PERFDB,
	GET_BRANCH_BY_NAME_AND_MASTERID,
	GET_FILTERED_BRANCHES_FOR_PERFDB,
	GET_BEST_LISTS_FOR_SELECTOR,
	FULL_UPDATE_BESTLIST,
	GET_BESTLIST_BY_ID,
	CREATE_DLO_DEFS,
	COPY_DEF_FROM_EXISTING,
	CREATE_EVENT_CLASS,
	CREATE_EVENT_CLASS_ARRAY,
	GET_CUSTOM_DEFS,
	UPDATE_CUSTOM_DEF,
	DELETE_BEST_LIST,
	GET_PERFORMANCELIST_LINKS,
	SET_LINKS,
};
